module.exports = __webpack_public_path__ + "static/Calluna-SemiboldIt-webfont-7e7794d223414bdbeddfc0c885fb7d06.woff";